import React from "react";
import { ProductOptionQuantitySelectors } from "./ProductOptionQuantitySelectors";

const PercentSaving = () => {
  return <ProductOptionQuantitySelectors savingsFormat={"percent"} />;
};

export default PercentSaving;
